import React, { useState } from "react";
import {
  Box,
  Paper,
  ClickAwayListener,
  Checkbox,
  MenuItem,
  IconButton,
} from "@mui/material";
import arrow from "../assets/arrow.svg";
import crossselect from "../assets/crossselect.svg";
import CustomText, { textStyles } from "./CustomText";
import { useTranslation } from "react-i18next";
import { useTheme } from "../contexts/ThemeContext";

const MultiSelectDropdown = ({
  label,
  name,
  values,
  onChange,
  options,
  isSingleSelect,
  enableSearch = false, // ✅ NEW PROP
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState(""); // ✅ Search input
  const { t } = useTranslation();
  const { primaryColor } = useTheme();

  // normalize
  const normalizedOptions = options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt } : opt
  );

  // filter options (only when search enabled)
  const filteredOptions = enableSearch
    ? normalizedOptions.filter((opt) =>
        opt.label.toLowerCase().includes(search.toLowerCase())
      )
    : normalizedOptions;

  // Compare loosely (String()) so numeric ids (e.g. from an API) and
  // stringified ids (e.g. from a stored form value) still match each other.
  const isValueSelected = (val) => values.some((v) => String(v) === String(val));

  const handleToggle = (option) => {
    const updated = isValueSelected(option.value)
      ? values.filter((item) => String(item) !== String(option.value))
      : isSingleSelect
      ? [option.value]
      : [...values, option.value];

    onChange({ target: { name, value: updated } });

    if (isSingleSelect) setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box sx={{ position: "relative", mb: 0.5 }}>
        <CustomText
          sx={{
            ...textStyles.body5,
            color: "#6B778C",
            pt: 1.2,
            textAlign: "left",
          }}
        >
          {label}
        </CustomText>

        <Box
          onClick={() => setOpen(!open)}
          sx={{
            height: 38,
            border: `2px solid ${primaryColor}20`,
            borderRadius: "6px",
            px: 2,
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            backgroundColor: "#fff",
            mt: 0.5,
          }}
        >
          <span style={{ color: values.length ? primaryColor : "#A0A0A0" }}>
            {t("select")}
          </span>
          <img src={arrow} alt="arrow" style={{ width: 18 }} />
        </Box>

        {open && (
          <Paper
            sx={{
              mt: 1,
              boxShadow: 1,
              borderRadius: 1,
              position: "absolute",
              zIndex: 9999,
              width: "100%",
              p: 1,
              backgroundColor: "white",
              maxHeight: 180,
              overflowY: "auto",
            }}
          >
            {/* 🔍 Search Bar (only if enableSearch=true) */}
            {enableSearch && (
              <input
                type="text"
                placeholder={t("search")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  marginBottom: 8,
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  fontSize: 14,
                }}
              />
            )}

            {/* Options */}
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt) => (
                <MenuItem
                  key={opt.value}
              onClick={(e) => {
    e.stopPropagation();        // ✅ IMPORTANT
    handleToggle(opt);
  }}
                  sx={{
                    gap: 1,
                    px: 1,
                    py: 0.5,
                    fontSize: "15px",
                    fontFamily: "Poppins, sans-serif",
                    minHeight: "unset",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {!isSingleSelect && (
                    <Checkbox
                      checked={isValueSelected(opt.value)}
                      size="small"
                      sx={{ p: 0.5 }}
                    />
                  )}

                  {opt.label}
                </MenuItem>
              ))
            ) : (
              <Box sx={{ p: 1, textAlign: "center", color: "#999" }}>
                {t("noResults")}
              </Box>
            )}
          </Paper>
        )}

        {/* Selected Pills */}
        {values.length > 0 && (
          <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.8 }}>
            {values.map((val) => {
              const option = normalizedOptions.find((o) => String(o.value) === String(val));
              return (
                <Box
                  key={val}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 0.8,
                    py: 1,
                    backgroundColor: "#579DFF",
                    borderRadius: "6px",
                    fontSize: "14px",
                    color: "#09326C",
                    fontWeight: 500,
                  }}
                >
                  {option ? option.label : val}
                  <IconButton
                    size="small"
                    onClick={() => handleToggle(option || { value: val })}
                    sx={{ ml: 0.3, p: 0 }}
                  >
                    <img
                      src={crossselect}
                      alt="remove"
                      style={{ width: 16, height: 16 }}
                    />
                  </IconButton>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default MultiSelectDropdown;





// import React, { useState } from "react";
// import {
//   Box,
//   Paper,
//   ClickAwayListener,
//   Checkbox,
//   MenuItem,
//   IconButton,
// } from "@mui/material";
// import arrow from "../assets/arrow.svg";
// import crossselect from "../assets/crossselect.svg";
// import CustomText, { textStyles } from "./CustomText";
// import { useTranslation } from "react-i18next";
// import { useTheme } from '../contexts/ThemeContext';

// const MultiSelectDropdown = ({ label, name, values, onChange, options, isSingleSelect }) => {
//   const [open, setOpen] = useState(false);
//   const { t } = useTranslation();
//   const { primaryColor, secondaryColor, primaryTextColor, secondaryTextColor } = useTheme();

//   // normalize options: always convert into {label, value}
//   const normalizedOptions = options.map((opt) =>
//     typeof opt === "string" ? { label: opt, value: opt } : opt
//   );

//   const handleToggle = (option) => {
//     const updated = values.includes(option.value)
//       ? values.filter((item) => item !== option.value)
//       : [...values, option.value];

//     onChange({ target: { name, value: updated } });

//     if (isSingleSelect) {
//       setOpen(false); // Close dropdown after single selection
//     }
//   };

//   return (
//     <ClickAwayListener onClickAway={() => setOpen(false)}>
//       <Box sx={{ position: "relative", mb: 0.5 }}>
//         <CustomText
//           sx={{
//             ...textStyles.body5,
//             color: "#6B778C",
//             pt: 1.2,
//             textAlign: "left",
//           }}
//         >
//           {label}
//         </CustomText>

//         <Box
//           onClick={() => setOpen(!open)}
//           sx={{
//             height: 38,
//             border: `2px solid ${primaryColor}20`,
//             borderRadius: "6px",
//             px: 2,
//             fontSize: 14,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             cursor: "pointer",
//             backgroundColor: "#fff",
//             mt: 0.5,
//           }}
//         >
//           <span style={{ color: values.length ? primaryColor : "#A0A0A0" }}>
//             {t("select")}
//           </span>
//           <img src={arrow} alt="arrow" style={{ width: 18 }} />
//         </Box>

//         {open && (
//           <Paper
//             sx={{
//               mt: 1,
//               boxShadow: 1,
//               borderRadius: 1,
//               position: "absolute",
//                  zIndex: 9999,   // 👈 bump it up

//               width: "100%",
//               p: 1,
//               backgroundColor: "white",
//               maxHeight: 150,
//               overflowY: "auto",
//             }}
//           >
//             {normalizedOptions.map((opt) => (
//               <MenuItem
//                 key={opt.value}
//                 onClick={() => handleToggle(opt)}
//                 sx={{
//                   gap: 1,
//                   px: 1,
//                   py: 0.5,
//                   fontSize: "15px",
//                   fontFamily: "Poppins, sans-serif",
//                   fontWeight: 400,
//                   lineHeight: 1.2,
//                   minHeight: "unset",
//                   display: "flex",
//                   alignItems: "center",
//                 }}
//               >
//                 {/* <Checkbox
//                   checked={values.includes(opt.value)}
//                   size="small"
//                   sx={{ p: 0.5 }}
//                 />
//                 {opt.label} */}
//                 {!isSingleSelect && (
//   <Checkbox
//     checked={values.includes(opt.value)}
//     size="small"
//     sx={{ p: 0.5 }}
//   />
// )}
// {opt.label}
//               </MenuItem>
//             ))}
//           </Paper>
//         )}

//         {values.length > 0 && (
//           <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.8 }}>
//             {values.map((val) => {
//               const option = normalizedOptions.find((o) => o.value === val);
//               return (
//                 <Box
//                   key={val}
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     px: 0.8,
//                     py: 1,
//                     backgroundColor: "#579DFF",
//                     borderRadius: "6px",
//                     fontSize: "14px",
//                     color: "#09326C",
//                     fontWeight: 500,
//                   }}
//                 >
//                   {option ? option.label : val}
//                   <IconButton
//                     size="small"
//                     onClick={() => handleToggle(option || { value: val })}
//                     sx={{ ml: 0.3, p: 0 }}
//                   >
//                     <img
//                       src={crossselect}
//                       alt="remove"
//                       style={{ width: 16, height: 16 }}
//                     />
//                   </IconButton>
//                 </Box>
//               );
//             })}
//           </Box>
//         )}
//       </Box>
//     </ClickAwayListener>
//   );
// };

// export default MultiSelectDropdown;





